import React, {
  useState,
  useCallback,
  useMemo,
  useContext,
  useEffect,
} from "react";
import { Col, Container, Row, Card, CardBody, CardHeader } from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb/BreadCrumb";
import { useQuery, useQueryClient } from "react-query";
import { DeleteOutlined, EditOutlined, EyeOutlined, LinkOutlined } from "@ant-design/icons";
import { Avatar, Button, Modal, Spin } from "antd";
import HistoryContext from "../../../Components/Hooks/HistoryContext";
import toast from "react-hot-toast";
import { deleteVehicule, getVehicules } from "../services/vehiculeApi";
import AddEditVehicleForm from "../component/AddEditVehiclesForm";
import "../../Styles/style.css";
import { getDrivers } from "../../Drivers/services/driverApi";
import { useTranslation } from "react-i18next";
import { getStatus } from "../../Status/services/statusApi";
import avatar1 from "../../../assets/images/users/avatar-user.png";
import { useNavigate } from "react-router-dom";
import vectorIcon from "../../../assets/images/Vector.png";
import vector1Icon from "../../../assets/images/Vector1.png";
import vectorStatut from "../../../assets/images/VectorStatut.png";
import TableContainerMin from "../../../Components/Common/TableContainer";
import AffectVehicleForm from "../component/AffectVehUser";
import { getUserById } from "../../Users/services/userApi";
import AddVehMass from "../component/fileMass/AddMassVehicles";

const Vehicules = (modal) => {
  const history = useContext(HistoryContext);
  const queryClient = useQueryClient();
  const { t } = useTranslation();
  document.title = `Véhicules | ${process.env.REACT_APP_NAME} - ${process.env.REACT_APP_DESCRIPTION}`;

  const [isAddEditModalOpen, setIsAddEditModalOpen] = useState(false);
  const [isAffectModalOpen, setIsAffectModalOpen] = useState(false);
  const [isMassModalOpen, setIsMassModalOpen] = useState(false);
  const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);
  const [selectedVehicule, setSelectedVehicule] = useState(null);
  const [deleteConfirmModal, setDeleteConfirmModal] = useState(false);
  const [deleteTargetId, setDeleteTargetId] = useState(null);
  const [driverName, setDriverName] = useState(null);
  const [deleteTargetRegistrationNumber, setDeleteTargetRegistrationNumber] =
    useState("");
  const {
    isLoading,
    isError,
    error,
    data: vehicules = [],
  } = useQuery("vehicules", getVehicules);
  const {
    data: drivers,
    isLoading: isLoadingDrivers,
    isError: isErrorDrivers,
  } = useQuery("drivers", getDrivers);
  const {
    data: status,
    isLoadingStatus: isLoadingStatus,
    isErrorStatus: isErrorStatus,
  } = useQuery("status", getStatus);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpenExport, setIsModalOpenExport] = useState(false);
  const toggleModal = useCallback((vehicule = null) => {
    setSelectedVehicule(vehicule);
    setIsModalOpen((prev) => !prev);
  }, []);

  const toggleModalExport = () => {
    setIsModalOpenExport((prev) => !prev);
  };

  const getStatusColor = (statut) => {
    switch (statut) {
      case "En service":
      case "En service #2FB550":
      case "Actif #2FB550":
        return "#2FB550";
      case "Hors service":
        return " #FF2D55";
      default:
        return " #FF9500";
    }
  };

  useEffect(() => {
    if (drivers) {
    }
  }, [drivers]);

  useEffect(() => {
    if (status) {
    }
  }, [status]);
  const toggleAddEditModal = useCallback(
    (vehicule = null) => {
      setSelectedVehicule(vehicule);
      setIsAddEditModalOpen((prev) => !prev);
      if (isDetailModalOpen) setIsDetailModalOpen(false);
    },
    [isDetailModalOpen]
  );

  const handleEdit = (vehicule) => {
    toggleAddEditModal(vehicule);
  };
  
  const handleMass = (vehicule) => {
    toggleAddEditModal(vehicule);
  };
  const toggleMassModal = useCallback(
    (vehicule = null) => {
      setIsMassModalOpen((prev) => !prev);
      if (isDetailModalOpen) setIsDetailModalOpen(false);
      if (isAddEditModalOpen) setIsAddEditModalOpen(false);
      if (isAffectModalOpen) setIsAffectModalOpen(false);
    },
    [isDetailModalOpen, , isAddEditModalOpen, isAffectModalOpen]
  );
  
  const toggleAffectModal = useCallback(
    (vehicule = null) => {
      setSelectedVehicule(vehicule);
      setIsAffectModalOpen((prev) => !prev);
      if (isDetailModalOpen) setIsDetailModalOpen(false);
      if (isAddEditModalOpen) setIsAddEditModalOpen(false);
    },
    [isDetailModalOpen, isAddEditModalOpen]
  );

  const handleAffect = async (vehicleId) => {
    try {
      const selectedDriverVeh = await getUserById(vehicleId);
      setDriverName(selectedDriverVeh?.name || 'Pas de chauffeur');
    } catch (error) {
      console.error('Error fetching user details:', error);
    }
    toggleAffectModal(vehicleId);
  };
  const toggleDetailModal = useCallback(
    (vehicule = null) => {
      setSelectedVehicule(vehicule);
      setIsDetailModalOpen((prev) => !prev);
      if (isAddEditModalOpen) setIsAddEditModalOpen(false);
    },
    [isAddEditModalOpen]
  );
  const handleDetail = (vehiculeId) => {
    if (vehiculeId) {
      navigate(`/vehicule/detail/${vehiculeId}`);
    }
  };
  const handleDelete = async (vehiculeId) => {
    try {
      await deleteVehicule(vehiculeId);
      queryClient.invalidateQueries("vehicules");
      toast.success("Le véhicule a été supprimée avec succès 🎉");
    } catch (error) {
      console.error("Error deleting vehicule:", error);
      toast.error(
        `😔 Erreur lors de la suppression de la véhicule : ${
          error?.message || error
        }`
      );
    } finally {
      setDeleteConfirmModal(false);
    }
  };
  const openDeleteConfirmModal = (vehiculeId) => {
    const vehiculeToDelete = vehicules.find(
      (vehicule) => vehicule.id === vehiculeId
    );
    if (vehiculeToDelete) {
      setDeleteTargetId(vehiculeId);
      setDeleteTargetRegistrationNumber(vehiculeToDelete.registrationNumber);
      setDeleteConfirmModal(true);
    }
  };
  const closeDeleteConfirmModal = () => {
    setDeleteConfirmModal(false);
  };
  const [isAllSelected, setIsAllSelected] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);

  // Gestion de la sélection/dé-sélection de toutes les cases
  const handleSelectAll = () => {
    setIsAllSelected(!isAllSelected);
    if (!isAllSelected) {
      // Sélectionner toutes les lignes
      setSelectedRows(vehicules.map((vehicule) => vehicule.id));
    } else {
      // Deselect toutes les lignes
      setSelectedRows([]);
    }
  };

  // Gestion de la sélection/dé-sélection d'une ligne spécifique
  const handleSelectRow = (id) => {
    setSelectedRows((prevSelectedRows) => {
      if (prevSelectedRows.includes(id)) {
        // Si la ligne est déjà sélectionnée, la désélectionner
        return prevSelectedRows.filter((rowId) => rowId !== id);
      } else {
        // Si la ligne n'est pas sélectionnée, la sélectionner
        return [...prevSelectedRows, id];
      }
    });
  };

  const columns = useMemo(
    () => [
      {
        Header: () => (
          <div
            style={{
              textAlign: "start",
              color: "#434343",
              fontSize: "14px",
              fontFamily: "Inter",
              fontWeight: "500px",
            }}
          >
            {t("vehicle.brand")}
          </div>
        ),
        accessor: "brand",
        Cell: ({ row }) => (
          <div
            style={{
              textAlign: "start",
              color: "#434343",
              fontFamily: "Inter",
              fontWeight: "400px",
              fontSize: "14px",
            }}
          >
            {row.original.brand || t("vehicle.no_registration_number")}
          </div>
        ),
        filterable: false,
      },
      {
        Header: () => (
          <div
            style={{
              textAlign: "",
              color: "#434343",
              fontSize: "14px",
              fontFamily: "Inter",
              fontWeight: "500px",
              marginLeft: "19px",
            }}
          >
            {t("vehicle.model")}
          </div>
        ),
        accessor: "select",
        Cell: ({ row }) => (
          <div style={{ textAlign: "start" }}>
            &nbsp;&nbsp;&nbsp;
            <span
              className="text-center"
              style={{
                color: "#434343",
                fontFamily: "Inter",
                fontWeight: "400px",
                fontSize: "14px",
              }}
            >
              {row.original.model || t("vehicle.no_registration_number")}
            </span>
          </div>
        ),
        filterable: false,
      },

      {
        Header: () => (
          <div
            style={{
              textAlign: "",
              color: "#434343",
              fontSize: "14px",
              fontFamily: "Inter",
              fontWeight: "500px",
              marginLeft: "19px",
            }}
          >
            {t("vehicle.driver")}
          </div>
        ),
        accessor: "actualUserId",
        Cell: ({ row }) => {
          const driverId = row.original.actualUserId;
          const driver = drivers?.find((driver) => driver.id === driverId);
          const avatarImage = driver?.fileName;
          const imageUrl = avatarImage
            ? `${process.env.REACT_APP_API_MEDIA_URL}/print/${avatarImage}`
            : avatar1;
          return (
            <div
              className="text-center"
              style={{ display: "flex", alignItems: "center" }}
            >
              {isLoadingDrivers ? (
                "Chargement..."
              ) : driver ? (
                <>
                  <Avatar
                    src={imageUrl}
                    alt=""
                    style={{
                      width: "30px",
                      height: "30px",
                      borderRadius: "50%",
                      marginRight: "8px",
                    }}
                  />
                  <span
                    style={{
                      color: "#434343",
                      fontFamily: "Inter",
                      fontWeight: "400px",
                      fontSize: "14px",
                    }}
                  >
                    {" "}
                    {driver.name}
                  </span>
                </>
              ) : (
                t("vehicle.no_driver")
              )}
            </div>
          );
        },
        filterable: false,
      },

      {
        Header: () => (
          <div
            style={{
              textAlign: "center",
              color: "#434343",
              fontSize: "14px",
              fontFamily: "Inter",
              fontWeight: "500px",
            }}
          >
            {t("vehicle.registration_number")}
          </div>
        ),
        accessor: "registrationNumber",
        Cell: ({ row }) => (
          <div
            className="text-center"
            style={{
              color: "#434343",
              fontFamily: "Inter",
              fontWeight: "400px",
              fontSize: "14px",
            }}
          >
            {row.original.registrationNumber ||
              t("vehicle.no_registration_number")}
          </div>
        ),

        filterable: false,
      },
      {
        Header: () => (
          <div
            style={{
              textAlign: "center",
              color: "#434343",
              fontSize: "14px",
              fontFamily: "Inter",
              fontWeight: "500px",
            }}
          >
            {t("vehicle.mileage")}
          </div>
        ),
        accessor: "mildeage",
        Cell: ({ row }) => (
          <div
            className="text-center"
            style={{
              color: "#434343",
              fontFamily: "Inter",
              fontWeight: "400px",
              fontSize: "14px",
            }}
          >
            {row?.original?.mileage || "---"}
          </div>
        ),
        filterable: false,
      },

      {
        Header: () => (
          <div
            style={{
              textAlign: "",
              color: "#434343",
              fontSize: "14px",
              fontFamily: "Inter",
              fontWeight: "500px",
            }}
          >
            {t("vehicle.commissioning_date")}
          </div>
        ),
        accessor: "commissioningDate",
        Cell: ({ value }) => (
          <div
            style={{
              textAlign: "center",
              color: "#434343",
              fontFamily: "Inter",
              fontWeight: "400px",
              fontSize: "14px",
            }}
          >
            {value ? new Date(value).toLocaleDateString("fr-FR") : "-"}
          </div>
        ),
        filterable: false,
      },
      {
        Header: () => (
          <div
            style={{
              textAlign: "start",
              color: "#434343",
              fontSize: "14px",
              fontFamily: "Inter",
              fontWeight: "500px",
            }}
          >
            {t("vehicle.status")}
          </div>
        ),
        accessor: "status",
        Cell: ({ row }) => {
          const statut = row?.original?.statut || "---";
          const color = getStatusColor(statut);
          return (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "start",
              }}
            >
              <span
                style={{
                  display: "inline-block",
                  width: "10px",
                  height: "10px",
                  borderRadius: "50%",
                  backgroundColor: color,
                  marginRight: "8px",
                }}
              ></span>
              <span
                style={{
                  color: "#434343",
                  fontFamily: "Inter",
                  fontWeight: "400px",
                  fontSize: "14px",
                }}
              >
                {statut}
              </span>
            </div>
          );
        },
        filterable: false,
      },

      {
        Header: () => (
          <div
            style={{
              textAlign: "end",
              color: "#434343",
              fontSize: "14px",
              fontFamily: "Inter",
              fontWeight: "500px",
            }}
          >
            {t("vehicle.actions")}
          </div>
        ),
        accessor: "action",
        headerStyle: { textAlign: "text-center" },
        Cell: ({ row }) => (
          <div className="actions-cell">
            <div
              style={{
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                width: "30px",
                height: "30px",
                backgroundColor: "#f5f5f5",
                borderRadius: "50%",
                boxShadow: "0 2px 5px rgba(0, 0, 0, 0.2)",
                cursor: "pointer",
              }}
              onClick={() => toggleModal(row.original)} // Ouvre le modal avec les détails de la ligne sélectionnée
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="6" cy="12" r="2" fill="#151515" />
                <circle cx="12" cy="12" r="2" fill="#151515" />
                <circle cx="18" cy="12" r="2" fill="#151515" />
              </svg>
            </div>
          </div>
        ),
        filterable: false,
      },
    ],
    [handleEdit, openDeleteConfirmModal, handleDetail, handleAffect]
  );

  const styles = {
    container: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    bigButton: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      padding: "5px 10px", // Réduit la taille du bouton
      backgroundColor: "#F6F6F6",
      color: "white",
      border: "none",
      borderRadius: "40px", // Légèrement arrondi mais plus petit
      cursor: "pointer",
      fontSize: "16px", // Taille réduite pour le texte
      position: "relative", // Pour contenir les onglets à l'intérieur
    },
    tabContainer: {
      display: "flex",
      gap: "5px", // Espacement réduit entre les onglets
      flexDirection: "row",
    },
    tabButton: {
      padding: "5px 16px", // Réduit la taille des onglets
      border: "none",
      borderRadius: "20px", // Onglets encore plus arrondis
      cursor: "pointer",
      fontSize: "14px",
      transition: "background-color 0.3s",
      font: "Inter",
      fontWeight: "bold",
      backgroundColor: "#F6F6F6",
    },
  };

  const vehiclesInService = vehicules.filter(
    (vehicule) => vehicule.statut === "En service"
  );
  const numberOfVehiclesInService = vehiclesInService.length;
  const vehiclesInHorsService = vehicules.filter(
    (vehicule) => vehicule.statut === "Hors service"
  );
  const numberOfVehiclesInHorsService = vehiclesInHorsService.length;
  const vehiclesArchive = vehicules.filter(
    (vehicule) => vehicule.statut === "Archives"
  );
  const numberOfVehiclesArchive = vehiclesArchive.length;
  const renderTabs = () => (
    <div className="d-flex gap-3 mb-3">
      <div style={styles.container}>
        <button style={styles.bigButton}>
          <div style={styles.tabContainer}>
            {tabs.map((tab) => (
              <button
                key={tab}
                style={{
                  ...styles.tabButton,
                  backgroundColor: activeTab === tab ? "#151515" : "#F6F6F6",
                  color: activeTab === tab ? "#FFFFFF" : "#595959",
                }}
                onClick={() => handleTabChange(tab)}
              >
                {tab}
                {tab === "Tout" && (
                  <div
                    style={{
                      display: "inline-flex",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "24px",
                      height: "24px",
                      borderRadius: "50%",
                      borderRadius: "50%",
                      backgroundColor:
                        activeTab === "Tout" ? "#3D3D3D" : "#D9D9D9", // Cercle blanc si actif, gris sinon
                      color: activeTab === "Tout" ? "#FFFFFF" : "#595959", // Couleur de texte en fonction de l'état
                      fontSize: "12px", // Correction de la taille de police
                      marginLeft: "5px",
                    }}
                  >
                    {vehicules?.length}
                  </div>
                )}
                {tab === "En service" && (
                  <div
                    style={{
                      display: "inline-flex",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "24px",
                      height: "24px",
                      borderRadius: "50%",
                      backgroundColor:
                        activeTab === "En service" ? "#3D3D3D" : "#D9D9D9", // Cercle blanc si actif, gris sinon
                      color: activeTab === "En service" ? "#FFFFFF" : "#595959",
                      fontSize: "12px",
                      marginLeft: "5px",
                    }}
                  >
                    {numberOfVehiclesInService}
                  </div>
                )}
                {tab === "Hors service" && (
                  <div
                    style={{
                      display: "inline-flex",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "24px",
                      height: "24px",
                      borderRadius: "50%",
                      backgroundColor:
                        activeTab === "Hors service" ? "#3D3D3D" : "#D9D9D9", // Cercle blanc si actif, gris sinon
                      color:
                        activeTab === "Hors service" ? "#FFFFFF" : "#595959",
                      fontSize: "12px",
                      marginLeft: "5px",
                    }}
                  >
                    {numberOfVehiclesInHorsService}
                  </div>
                )}
                {tab === "En réparation" && (
                  <div
                    style={{
                      display: "inline-flex",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "24px",
                      height: "24px",
                      borderRadius: "50%",
                      backgroundColor:
                        activeTab === "En réparation" ? "#3D3D3D" : "#D9D9D9", // Cercle blanc si actif, gris sinon
                      color:
                        activeTab === "En réparation" ? "#FFFFFF" : "#595959",
                      fontSize: "12px",
                      marginLeft: "5px",
                    }}
                  >
                    {numberOfVehiclesArchive}
                  </div>
                )}
              </button>
            ))}
          </div>
        </button>
      </div>
    </div>
  );
  const tabs = ["Tout", "En service", "Hors service", "En réparation"];
  const [activeTab, setActiveTab] = useState("Tout");
  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };
  <div className="d-flex gap-3">{renderTabs()}</div>;
  const navigate = useNavigate();
  const HeaderTable = () => (
    <div className="gap-3">
      <div className="d-flex justify-content-between align-items-center w-100">
        <div className="d-flex gap-3">
          <strong style={{ fontSize: "24px" }}>
            {t("vehicle.vehicle_list")}
          </strong>
        </div>

        {/* Conteneur flex pour aligner les deux boutons */}
        <div
          style={{
            display: "flex",
            alignItems: "center", // Aligne verticalement les boutons
            gap: "10px", // Espacement entre les boutons
          }}
        >
          {/* Bouton Export */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "30px", // Taille réduite
              height: "30px",
              backgroundColor: "#f5f5f5",
              borderRadius: "50%",
              boxShadow: "0 2px 5px rgba(0, 0, 0, 0.2)",
              cursor: "pointer", // Ajout du curseur pointer pour indiquer que c'est cliquable
            }}
            onClick={toggleModalExport}
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              {/* Points du bouton d'export */}
              <circle cx="6" cy="12" r="2" fill="#151515" />
              <circle cx="12" cy="12" r="2" fill="#151515" />
              <circle cx="18" cy="12" r="2" fill="#151515" />
            </svg>
          </div>

          {/* Bouton Ajouter un véhicule */}
          <button
            className="buttonAdd"
            onMouseOver={(e) => (e.target.style.backgroundColor = " #151515")}
            onMouseOut={(e) => (e.target.style.backgroundColor = " #151515")}
            onClick={() => toggleAddEditModal(null)}
          >
            {t("vehicle.add_new_vehicle")}
          </button>
        </div>
      </div>
      <div style={{ marginTop: "20px" }}></div>
      {renderTabs()}
    </div>
  );
  const filteredVehicules = useMemo(() => {
    if (!vehicules) return error?.message || [];
    switch (activeTab) {
      case "En service":
        return vehicules.filter((v) => v.statut === "En service");
      case "Hors service":
        return vehicules.filter((v) => v.statut === "Hors service");
      case "En réparation":
        return vehicules.filter((v) => v.statut === "En réparation");
      default:
        return vehicules;
    }
  }, [vehicules, activeTab]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb page={t("vehicle.vehicles")} history={history} />
          <Row>
            <Col>
              <Card id="contactList">
                <CardHeader>
                  <HeaderTable />
                </CardHeader>
                <CardBody className="pt-0">
                  <TableContainerMin
                    columns={columns}
                    data={filteredVehicules || []}
                    isGlobalSearch={true}
                    isGlobalFilter={true}
                    customPageSize={5}
                    className="custom-header-css"
                    divClass="table-responsive table-card mb-3"
                    tableClass="align-middle table-nowrap"
                    theadClass="table-light"
                  />
                  {isLoading && !isError && (
                    <div className="text-center">
                      {t("global.loading")}
                      <Spin />
                    </div>
                  )}
                  {filteredVehicules &&
                    filteredVehicules.length === 0 &&
                    !isLoading && <div>{t("global.no-data-v")}</div>}
                </CardBody>
              </Card>
            </Col>
          </Row>
          <AddEditVehicleForm
            modal={isAddEditModalOpen}
            setModal={setIsAddEditModalOpen}
            toggle={toggleAddEditModal}
            selectedVehicule={selectedVehicule}
          />
          <AddVehMass
            modal={isMassModalOpen}
            setModal={setIsMassModalOpen}
            toggle={toggleMassModal}
          />
          <AffectVehicleForm
            modal={isAffectModalOpen}
            setModal={setIsAffectModalOpen}
            toggle={toggleAffectModal}
            selectedVehicule={selectedVehicule}
            actualDriver={driverName}
          />
          <Modal
            title="Confirmer la suppression de ce véhicule"
            open={deleteConfirmModal}
            onCancel={closeDeleteConfirmModal}
            footer={[
              <Button
                key="cancel"
                onClick={closeDeleteConfirmModal}
                className="bordered-btn-delete"
              >
                {t("global.no")}
              </Button>,
              <Button
                key="delete"
                type="danger"
                onClick={() => handleDelete(deleteTargetId)}
                className="bordered-btn"
              >
                {t("global.yes")}
              </Button>,
            ]}
            width={400}
            style={{ top: 200 }}
          >
            <p>
              {t("vehicle.confirm_delete_vehicle")}{" "}
              {deleteTargetRegistrationNumber} ?
            </p>
          </Modal>
          <Modal
            className={`modal-right ${modal ? "open" : ""}`}
            visible={isModalOpenExport}
            onCancel={toggleModalExport}
            footer={null}
            width={300}
            height={120}
            radiuis={9.6}
            border={0.96}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <a
                onClick={() => {
                toggleMassModal(null);
                }}
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginRight: "8px",
                  fontFamily: "inter",
                  fontWeight: "400px",
                  size: "14px",
                  color: "#252525",
                  width: "100%",
                  marginBottom: "16px",
                }}
              >
                <img src={vectorIcon} alt="Ajouter plusieurs véhicules" />
                <span>Ajouter plusieurs véhicules</span>
              </a>
              <a
                onClick={() => {
                  toggleModalExport();
                }}
                style={{
                  marginRight: "8px",
                  fontFamily: "inter",
                  fontWeight: "400px",
                  fontSize: "14px",
                  color: "#252525",
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <img
                  src={vector1Icon}
                  alt="Export en csv"
                  style={{ marginRight: "8px" }}
                />
                <span>Exporter en CSV</span>
              </a>
            </div>
          </Modal>
          <Modal
            open={isModalOpen}
            onCancel={() => toggleModal()}
            footer={null}
            width={206}
            height={10}
            radiuis={9.6}
            border={0.96}
            style={{ top: "350px", right: "10px", position: "absolute" }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <a
                onClick={() => handleDetail(selectedVehicule?.id)}
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginRight: "8px",
                  fontFamily: "inter",
                  fontWeight: "400px",
                  width: "100%",
                  marginBottom: "16px",
                }}
              >
                <EyeOutlined style={{ color: " #898989", width: "20px" }} />
                <span style={{ size: "14px", color: " #252525" }}>
                  Voir détails
                </span>
              </a>
              <a
                onClick={() => handleEdit(selectedVehicule)}
                style={{
                  marginRight: "8px",
                  fontFamily: "inter",
                  fontWeight: "400px",
                  fontSize: "14px",
                  color: "#252525",
                  width: "100%",
                  display: "flex",
                  marginBottom: "16px",
                }}
              >
                <EditOutlined style={{ color: " #898989" }} />
                <span style={{ marginLeft: "10px" }}>Editer véhicule</span>
              </a>
              <a
                onClick={() => openDeleteConfirmModal(selectedVehicule.id)}
                style={{
                  marginRight: "8px",
                  fontFamily: "inter",
                  fontWeight: "400px",
                  fontSize: "14px",
                  color: "#252525",
                  width: "100%",
                  marginBottom: "16px",
                }}
              >
                <DeleteOutlined style={{ color: " #898989" }} />
                <span style={{ marginLeft: "10px" }}>Archiver ce véhicule</span>
              </a>
              <a
                onClick={() => {
                  console.log("Exportation CSV...");
                  toggleModal();
                }}
                style={{
                  marginRight: "8px",
                  fontFamily: "inter",
                  fontWeight: "400px",
                  fontSize: "14px",
                  color: "#252525",
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <img
                  src={vectorStatut}
                  alt="Export en csv"
                  style={{ width: "15px" }}
                />
                <span style={{ marginLeft: "10px" }}>Changer le statut</span>
              </a>
              <a
                onClick={() => handleAffect(selectedVehicule.id)}
                style={{
                  marginRight: "8px",
                  fontFamily: "inter",
                  fontWeight: "400px",
                  fontSize: "14px",
                  color: "#252525",
                  width: "100%",
                  marginBottom: "16px",
                }}
              >
                <LinkOutlined style={{ color: " #898989" }} />
                <span style={{ marginLeft: "10px" }}>Affecter</span>
              </a>
            </div>
          </Modal>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Vehicules;
